export default __webpack_public_path__ + "65eaccec1dcf17811007156fc824af04.png";